import * as React from "react";
import { useTranslation } from "react-i18next";
import { LinkContainer, DocumentTitle, PageHeader } from "components/common";
import { Button } from "components/bootstrap";
import UsersPageNavigation from "components/users/navigation/UsersPageNavigation";
import SecurityRoutes from "security/Routes";
import TeamCreate from "../components/team-create/TeamCreate";
const TeamCreatePage = () => {
  const { t } = useTranslation("enterprise_security");
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: t("team_create_page.title") }, /* @__PURE__ */ React.createElement(UsersPageNavigation, null), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: t("team_create_page.title"),
      actions: /* @__PURE__ */ React.createElement(LinkContainer, { to: SecurityRoutes.TEAMS.CREATE }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary" }, t("team_create_page.create_team")))
    },
    /* @__PURE__ */ React.createElement("span", null, t("team_create_page.description")),
    /* @__PURE__ */ React.createElement("span", null)
  ), /* @__PURE__ */ React.createElement(TeamCreate, null));
};
export default TeamCreatePage;
